module.exports = __webpack_public_path__ + "img/goals-light-green-small.a710916a.svg";